<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">

        <h3>Lista Vaccini</h3>

        <div class="card mb-4" v-for="(v, index) in vaccines" :key="index">
          <div class="card-header pb-0">
            <h4>{{ v.label }}</h4>
            <button v-if="!horse_vaccines['vaccine_id_'+v.value]?.id" type="button" id="add-btn" class="btn btn-primary" @click="clear(v.value)" data-bs-toggle="modal" data-bs-target="#formModal">+ Nuovo</button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-3">
              <table class="table mb-0">
                <thead>
                <tr>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                    Data
                  </th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Scadenza
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Fatto
                  </th>
                  <th class="text-secondary opacity-7"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="horse_vaccines['vaccine_id_'+v.value]?.id">
                  <td class="align-middle">
                    <span class="text-secondary font-weight-bold">{{ $moment(horse_vaccines['vaccine_id_' + v.value].date).format('L') }}</span>
                  </td>
                  <td class="align-middle">
                    <span class="text-secondary font-weight-bold">{{ $moment(horse_vaccines['vaccine_id_' + v.value].expiration).format('L') }}</span>
                  </td>
                  <td class="align-middle text-center">
                    <soft-badge :color="horse_vaccines['vaccine_id_'+v.value].done? 'success' : 'secondary'" variant="gradient" size="sm">{{ horse_vaccines['vaccine_id_' + v.value].done ? 'SI' : 'NO' }}</soft-badge>
                  </td>
                  <td class="align-middle">
                    <a
                        href="javascript:;"
                        class="text-secondary font-weight-bold text-xs"
                        data-toggle="tooltip"
                        @click="edit(horse_vaccines['vaccine_id_'+v.value].id)"
                        data-original-title="Edit user"
                    >Modifica</a
                    >
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>


  <div class="modal fade" id="formModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="add" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="formModalBtn">Vaccino</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" style="color: black;"></button>
        </div>
        <div class="modal-body">
          <Vueform ref="form$" v-model="vaccine" sync>
            <HiddenElement name="id"/>
            <HiddenElement name="vaccine_id"/>
            <DateElement name="date"  label="Data" rules="required"></DateElement>
            <DateElement name="expiration" label="Scadenza" rules="required"></DateElement>
            <!-- <SelectElement
                name="vaccine_id"
                :native="false"
                label="Vaccine"
                rules="required"
                :items="vaccines"
            /> -->
            <ToggleElement name="done">
              Fatto
            </ToggleElement>
          </Vueform>

        </div>
        <div class="modal-footer">
          <button type="button" id="close" class="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
          <button type="button" class="btn btn-primary" :class="{ loading: loading }" @click="save">Salva</button>
        </div>
      </div>
    </div>
  </div>

</template>


<script>

import {horsesVaccineService} from "@/services/HorsesVaccineService";
import {useToast} from "vue-toastification";
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import SoftBadge from "@/components/SoftBadge.vue";

const toast = useToast();

export default {
  name: "HorseVaccins",
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      vaccine: {},
      vaccines: [],
      horse_vaccines: [],
    };
  },
  mounted() {
    horsesVaccineService.getVaccines().then(vaccines => this.vaccines = vaccines.map(v => ({value: v.id, label: v.type})));
    horsesVaccineService.getHorseVaccines(this.id).then(vaccines => this.horse_vaccines = vaccines);
  },
  computed: {},
  components: {
    SoftBadge
  },
  created() {
    this.$store.dispatch('updateBreadcrumbs', [
      { title: 'Lista Cavalli', name: 'Horses' },
      { title: 'Cavallo', name: 'Horse', params: { id: this.id } },
      { title: 'Salute', name: 'HorseHealth', params: { id: this.id } },
    ]);
  },
  methods: {
    async edit(id) {
      horsesVaccineService.getHorseVaccineById(id).then((vaccine) => {
        this.vaccine = vaccine;
        this.loading = false;
        const modalElement = document.getElementById('formModal');
        const myModal = new bootstrap.Modal(modalElement);
        myModal.show();
      });
    },
    clear(vid){
      console.log('VID:', vid)
      this.vaccine = {vaccine_id: vid};
      this.$refs.form$.reset();
      this.$refs.form$.el$('vaccine_id')?.update(vid);
    },
    async save() {
      const form = this.$refs.form$;
      form.validate();
      if (this.vaccine.id) form.data.id = this.vaccine.id;
      form.data.vaccine_id = this.vaccine.vaccine_id;
      form.data.horse_id = this.id;
      if (!form.hasErrors) {
        for (const key in form.data) {
          if (form.data[key] === 'null' || form.data[key] === null) {
            delete form.data[key];
          }
        }
        this.loading = true;
        try {
          await horsesVaccineService.saveHorseVaccine(form.data);
          toast(this.$t('operation_saved'));
          document.getElementById('close').click();
          horsesVaccineService.getHorseVaccines(this.id).then(vaccines => this.horse_vaccines = vaccines);
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>
